import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue";
const _hoisted_1 = { class: "system-settings-page" };
const _hoisted_2 = { key: 1 };
import { ref, computed, onMounted } from 'vue';
import { useAdmin } from '@/composables/useAdmin';
import AdminTable from '@/admin/components/AdminTable.vue';
import SuccessToast from '@/components/elements/SuccessToast.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'SystemSettingsPage',
    setup(__props) {
        const admin = useAdmin();
        const tables = {};
        const loading = ref(false);
        const settings = ref([]);
        const savedCount = ref(0);
        const showError = ref(false);
        const errorMessage = ref('');
        const search = ref('');
        const columns = [
            { field: 'key', label: 'Setting', width: '3fr', sortable: true, editable: false },
            { field: 'value', label: 'Value', width: '2fr', sortable: true, editable: true, type: 'text', placeholder: 'Value' },
            { field: 'lastUpdated', label: 'Last Updated', width: '1fr', sortable: true, editable: false }
        ];
        // Namespace = everything before the last dot, e.g. Syso.Services.AIChat
        function namespaceOf(key) {
            return key.includes('.') ? key.slice(0, key.lastIndexOf('.')) : 'General';
        }
        const groups = computed(() => {
            const q = (search.value || '').toLowerCase();
            const byNamespace = {};
            settings.value
                .filter((s) => !q || s.key.toLowerCase().includes(q) || (s.value || '').toLowerCase().includes(q))
                .forEach((s) => { var _a; return (byNamespace[_a = namespaceOf(s.key)] || (byNamespace[_a] = [])).push(s); });
            return Object.keys(byNamespace).sort().map(namespace => ({
                namespace,
                rows: byNamespace[namespace].sort((a, b) => a.key.localeCompare(b.key))
            }));
        });
        function formatDate(value) {
            if (!value)
                return '—';
            return new Date(value).toLocaleString('en-GB', { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit' });
        }
        function load() {
            loading.value = true;
            admin.getSystemSettings((data) => {
                settings.value = data || [];
                loading.value = false;
            });
        }
        function handleEditSave({ rowId, data }) {
            const existing = settings.value.find((s) => s.id === rowId);
            // ponytail: send only id/key/value — AdminTable turns a null lastUpdated into '', which the API rejects as a DateTime?
            admin.saveSystemSetting({ id: existing.id, key: existing.key, value: data.value || null }, () => {
                tables[namespaceOf(existing.key)]?.cancelEdit();
                savedCount.value = 1;
                load();
            }, (error) => {
                errorMessage.value = error;
                showError.value = true;
            });
        }
        onMounted(load);
        return (_ctx, _cache) => {
            const _component_v_text_field = _resolveComponent("v-text-field");
            const _component_v_progress_linear = _resolveComponent("v-progress-linear");
            const _component_v_btn = _resolveComponent("v-btn");
            const _component_v_snackbar = _resolveComponent("v-snackbar");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(_component_v_text_field, {
                    modelValue: search.value,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((search).value = $event)),
                    placeholder: "Search settings...",
                    "prepend-inner-icon": "mdi-magnify",
                    density: "compact",
                    variant: "outlined",
                    clearable: "",
                    "hide-details": "",
                    class: "settings-search"
                }, null, 8, ["modelValue"]),
                (loading.value)
                    ? (_openBlock(), _createBlock(_component_v_progress_linear, {
                        key: 0,
                        indeterminate: ""
                    }))
                    : (!groups.value.length)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_2, "No system settings found."))
                        : _createCommentVNode("", true),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(groups.value, (group) => {
                    return (_openBlock(), _createBlock(AdminTable, {
                        key: group.namespace + !!search.value,
                        ref_for: true,
                        ref: (el) => el && (tables[group.namespace] = el),
                        title: group.namespace,
                        columns: columns,
                        data: group.rows,
                        badge: group.rows.length,
                        collapsible: true,
                        "default-expanded": !!search.value,
                        editable: true,
                        selectable: false,
                        deletable: false,
                        addable: false,
                        onRowEditSave: handleEditSave
                    }, {
                        "cell-key": _withCtx(({ row }) => [
                            _createTextVNode(_toDisplayString(row.key.slice(group.namespace.length + 1)), 1)
                        ]),
                        "cell-lastUpdated": _withCtx(({ row }) => [
                            _createTextVNode(_toDisplayString(formatDate(row.lastUpdated)), 1)
                        ]),
                        _: 2
                    }, 1032, ["title", "data", "badge", "default-expanded"]));
                }), 128)),
                _createVNode(_component_v_snackbar, {
                    modelValue: showError.value,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((showError).value = $event)),
                    timeout: 4000,
                    location: "bottom",
                    color: "error"
                }, {
                    actions: _withCtx(() => [
                        _createVNode(_component_v_btn, {
                            icon: "mdi-close",
                            size: "small",
                            onClick: _cache[1] || (_cache[1] = ($event) => (showError.value = false))
                        })
                    ]),
                    default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(errorMessage.value) + " ", 1)
                    ]),
                    _: 1
                }, 8, ["modelValue"]),
                _createVNode(SuccessToast, {
                    count: savedCount.value,
                    "onUpdate:count": _cache[3] || (_cache[3] = ($event) => ((savedCount).value = $event)),
                    message: "Setting saved"
                }, null, 8, ["count"])
            ]));
        };
    }
});
